import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import { PdfLogo } from '@/styled/icon';
import dayjs from 'dayjs';
import main01 from '@static/image/main01.png';
import main02 from '@static/image/main02.png';
import main04 from '@static/image/main04.png';
import moIndex from '../../store';

interface IProps {}
interface IState {}

const MainPage = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const now = new Date(); // 当前日期
  const nowMonth = dayjs(now).format('MM'); // 当前月
  const nowYear = now.getFullYear(); // 当前年
  const nowData = dayjs(now).format('DD'); // 当前年

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="main-page">
      <PdfLogo />
      <section className="main-page-content">
        <img
          src="https://file.smartsalary.cn/index-pdf/01.png"
          alt=""
          className="bg-main"/>
        <section className="title-contents">
          <section className="top">
            <p>{nowYear}</p>
            <p>{moIndex.industry.name}行业白皮书</p>
          </section>
          <section className="mid">
            <img src={main01} alt="" />
            <p>人力核心指标</p>
            <p>行业报告系列</p>
          </section>
          <section className="bot">
            <img
              src={main04}
              alt=""/>
            <p>
              {nowYear} - {nowMonth} - {nowData}
            </p>
            <img src={main02} alt="" />
          </section>
        </section>
      </section>
    </section>
  );
};

export default observer(MainPage);
